import React, { useState, useEffect } from 'react';
import Modal from '../../layout/modal/Modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setMinutes, setHours } from 'date-fns';
import CustomButton from '../../layout/customButton/CustomButton';
import styles from './ScheduleMeeting.module.scss';
import { connect } from 'react-redux';
import { upcommingAppointments } from '../../../redux/appointments/actions';
import { scheduleAppointment } from '../../../api/Appointments/appointments.api';
import { Divider, TextField } from '@material-ui/core';
import CustomAlerts from '../../alerts/CustomAlerts';
import { closeModal } from '../../../redux/modals/action';
import { useHistory } from 'react-router';
import moment from 'moment';
import changeMeetingStatus from '../../../api/Leads/changeMeetingStatus.api';
import { validateEmail } from '../../../utils/validateEmail';
import {
	reformatPhoneString,
	removeAlphabeticalCharWithMaxLength,
	validatePhoneNumber,
} from '../../../utils/validatePhoneNumber';

const ScheduleMeeting = (props) => {
	const {
		// Parent props
		showModal,
		setLoading,
		handleScheduleModalClose,
		hasPreviousModal,
		dateClicked,
		scheduleModal,
		// Redux
		salesAgentId,
		leadById,
		upcommingAppointmentsArray,
		closeModal,
	} = props;
	const [startDate, setStartDate] = useState(new Date());
	const [clientFullName, setClientFullName] = useState('');
	const [clientEmail, setClientEmail] = useState('');
	const [clientPhoneNumber, setClientPhoneNumber] = useState('');
	const [guest1Email, setGuest1Email] = useState('');
	const [guest2Email, setGuest2Email] = useState('');
	const [snackbar, setSnackbar] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [snackbarType, setSnackbarType] = useState('');
	const [fullNameError, setFullNameError] = useState(false);
	const [fullNameErrorMsg, setFullNameErrorMsg] = useState('');
	const [emailError, setEmailError] = useState(false);
	const [emailErrorMsg, setEmailErrorMsg] = useState('');
	const [guestEmailError, setGuestEmailError] = useState(false);
	const [guestEmailErrorMsg, setGuestEmailErrorMsg] = useState('');

	var history = useHistory();

	useEffect(() => {
		if (dateClicked) {
			let isNotPassed = filterPassedTime(dateClicked);
			let time = new Date();
			let hour = time.getHours();
			let min = time.getMinutes();
			let displayMin = 0;
			let displayHour = hour;
			if (min < 15) {
				displayMin = 15;
			} else if (15 <= min && min < 30) {
				displayMin = 30;
			} else if (30 <= min && min < 45) {
				displayMin = 45;
			} else {
				displayHour = displayHour + 1;
			}

			isNotPassed
				? dateClicked.getHours() < 7
					? setStartDate(setHours(setMinutes(dateClicked, 0), 7))
					: setStartDate(dateClicked)
				: setStartDate(
						setHours(
							setMinutes(dateClicked, displayMin),
							displayHour
						)
				  );
		}
	}, [dateClicked]);

	useEffect(() => {
		if (history.location.pathname === '/deals') {
			setClientFullName(
				leadById?.clientFName + ' ' + leadById?.clientLName
			);
			setClientEmail(leadById?.clientEmail);
			setClientPhoneNumber(leadById?.clientPhoneNumber);
		}
	}, [leadById]);

	const resetModalData = () => {
		if (history.location.pathname !== '/deals') {
			setClientFullName('');
			setClientEmail('');
			setClientPhoneNumber('');
			setGuest1Email('');
			setGuest2Email('');
		} else {
			setClientFullName(
				leadById?.clientFName + ' ' + leadById?.clientLName
			);
			setClientEmail(leadById?.clientEmail);
			setClientPhoneNumber(leadById?.clientPhoneNumber);
			setGuest1Email('');
			setGuest2Email('');
		}
	};

	const saveHandler = () => {
		if (!filterPassedTime(startDate)) {
			displayAlert(
				'You cannot select earlier than current time',
				'error'
			);
		} else if (clientFullName.length === 0 || clientEmail.length === 0) {
			if (clientFullName.length === 0) {
				setFullNameError(true);
				setFullNameErrorMsg('Full name is required');
			}
			if (clientEmail.length === 0) {
				setEmailError(true);
				setEmailErrorMsg('Email is required');
			}
		} else if (!validateEmail(clientEmail)) {
			setEmailError(true);
			setEmailErrorMsg('Invalid email address');
		} else if (guest1Email.length > 0 && guest1Email === guest2Email) {
			setGuestEmailError(true);
			setGuestEmailErrorMsg('Guest email addresses are same');
		} else {
			let duplicateMeeting = false;
			if (upcommingAppointmentsArray) {
				for (var i = 0; i < upcommingAppointmentsArray.length; i++) {
					let appointmentTimestamp =
						upcommingAppointmentsArray[i].appointmentTime;
					let startDateTimestamp = moment(startDate).unix() * 1000;
					if (appointmentTimestamp === startDateTimestamp) {
						duplicateMeeting = true;
						displayAlert(
							'You have an upcoming meeting at the same time you selected. Please try a different time slot.',
							'error'
						);
						break;
					}
				}
			}
			if (!duplicateMeeting) {
				let date = new Date(startDate);
				let timeInMillisec = date.getTime();
				let appointmentPost;
				appointmentPost = {
					appointmentID: 'none',
					appointmentName: 'Adhoc_Appointment_Made_by_Admin_',
					timeOfAppointment: timeInMillisec,
					assignedTo: 'Adhoc',
					started: false,
					createrID: salesAgentId,
					sentRemind: false,
					createUser: true,
					createTimestamp: new Date().getTime(),
				};
				if (history.location.pathname === '/deals') {
					appointmentPost = {
						appointmentID: 'none',
						appointmentName: 'Adhoc_Appointment_Made_by_Admin_',
						timeOfAppointment: timeInMillisec,
						assignedTo: 'Adhoc',
						started: false,
						createrID: salesAgentId,
						sentRemind: false,
						createUser: true,
						createTimestamp: new Date().getTime(),
						leadId: leadById?.leadId,
						leadToSalesAgent: leadById?.leadToSalesAgent,
					};
					changeMeetingStatus(
						leadById?.leadId,
						leadById?.leadToSalesAgent
					);
				} else {
					appointmentPost = {
						appointmentID: 'none',
						appointmentName: 'Adhoc_Appointment_Made_by_Admin_',
						timeOfAppointment: timeInMillisec,
						assignedTo: 'Adhoc',
						started: false,
						createrID: salesAgentId,
						sentRemind: false,
						createUser: true,
						createTimestamp: new Date().getTime(),
					};
				}
				let users = {
					0: {
						email: clientEmail,
						fullName: clientFullName,
						phoneNumber: clientPhoneNumber,
					},
				};
				if (guest1Email) {
					users['1'] = {
						email: guest1Email,
						fullName: 'undefined',
						phoneNumber: 'undefined',
					};
				}
				if (guest2Email) {
					users['2'] = {
						email: guest2Email,
						fullName: 'undefined',
						phoneNumber: 'undefined',
					};
				}
				appointmentPost['users'] = users;
				scheduleAppointment(
					appointmentPost,
					(loading) => {
						setLoading(loading);
					},
					(message, type) => {
						displayAlert(message, type);
					}
				);
				if (hasPreviousModal && leadById?.leadId)
					handleScheduleModalClose(leadById?.leadId);
				else closeModal('scheduleMeeting');

				resetModalData();
			}
		}
	};

	const onChangeHandler = (e) => {
		if (guestEmailError) {
			setGuestEmailError(false);
			setGuestEmailErrorMsg('');
		}
		if (e.target.name === 'clientFullName') {
			setClientFullName(e.target.value);
			clearClientFullNameError();
		} else if (e.target.name === 'clientEmail') {
			setClientEmail(e.target.value);
			clearClientEmailError();
		} else if (e.target.name === 'clientPhoneNumber') {
			let phoneNum = removeAlphabeticalCharWithMaxLength(e.target.value);
			if (validatePhoneNumber(phoneNum)) {
				setClientPhoneNumber(reformatPhoneString(phoneNum));
			} else {
				setClientPhoneNumber(phoneNum);
			}
		} else if (e.target.name === 'guest1Email') {
			setGuest1Email(e.target.value);
		} else if (e.target.name === 'guest2Email') {
			setGuest2Email(e.target.value);
		}
	};

	const closeHandler = () => {
		if (hasPreviousModal && leadById?.leadId) {
			handleScheduleModalClose(leadById?.leadId);
		} else {
			closeModal('scheduleMeeting');
		}
		resetModalData();
		clearClientFullNameError();
		clearClientEmailError();
	};

	const displayAlert = (message, type) => {
		setSnackbar(true);
		setSnackbarMessage(message);
		setSnackbarType(type);
		setTimeout(() => {
			setSnackbar(false);
		}, 3500);
	};

	const clearClientFullNameError = () => {
		if (fullNameError) {
			setFullNameError(false);
			setFullNameErrorMsg('');
		}
	};

	const clearClientEmailError = () => {
		if (emailError) {
			setEmailError(false);
			setEmailErrorMsg('');
		}
	};
	const filterPassedTime = (time) => {
		const currentDate = new Date();
		const selectedDate = new Date(time);

		return currentDate.getTime() < selectedDate.getTime();
	};
	return (
		<div className={styles.schedule_meetring_modal}>
			<CustomAlerts
				alertType={snackbarType}
				alertMsg={snackbarMessage}
				snackbar={snackbar}
				setSnackbar={setSnackbar}
			/>
			<Modal
				show={showModal}
				close={closeHandler}
				title='Schedule Meeting'
			>
				<div className={styles.schedule_meeting}>
					<div className={styles.date_picker}>
						<DatePicker
							selected={startDate}
							onChange={(date) => setStartDate(date)}
							showTimeSelect
							timeFormat='HH:mm'
							timeIntervals={15}
							timeCaption='time'
							dateFormat='MMMM d, yyyy h:mm aa'
							width='200px'
							minDate={Date.now()}
							minTime={setHours(setMinutes(new Date(), 0), 7)}
							filterTime={filterPassedTime}
							maxTime={setHours(setMinutes(new Date(), 0), 20)}
						/>
					</div>
					<Divider />
					<div className={styles.client_info}>
						<h3>Client Info</h3>
						<TextField
							error={fullNameError}
							helperText={fullNameErrorMsg}
							name='clientFullName'
							label='Full name'
							variant='outlined'
							className={styles.input}
							fullWidth
							value={clientFullName}
							onChange={(e) => onChangeHandler(e)}
							required
						/>
						<TextField
							error={emailError}
							helperText={emailErrorMsg}
							name='clientEmail'
							label='Email address'
							variant='outlined'
							className={styles.input}
							fullWidth
							value={clientEmail}
							onChange={(e) => onChangeHandler(e)}
							required
						/>
						<TextField
							name='clientPhoneNumber'
							label='Phone number'
							variant='outlined'
							className={styles.input}
							fullWidth
							value={clientPhoneNumber}
							onChange={(e) => onChangeHandler(e)}
						/>
						<TextField
							error={guestEmailError}
							helperText={guestEmailErrorMsg}
							name='guest1Email'
							label='Guest 1 email'
							variant='outlined'
							className={styles.input}
							fullWidth
							value={guest1Email}
							autoComplete='guest-email1'
							onChange={(e) => onChangeHandler(e)}
						/>
						<TextField
							error={guestEmailError}
							helperText={guestEmailErrorMsg}
							name='guest2Email'
							label='Guest 2 email'
							variant='outlined'
							className={styles.input}
							fullWidth
							value={guest2Email}
							autoComplete='guest-email2'
							onChange={(e) => onChangeHandler(e)}
						/>
					</div>
					<div className={styles.buttons}>
						<CustomButton
							width={160}
							height={42}
							onClick={saveHandler}
						>
							Save
						</CustomButton>
					</div>
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	salesAgentId: state.signIn.uid,
	leadById: state.leads.leadById || state.purchasers.purchaserById,
	upcommingAppointmentsArray: state?.appointments?.upcommingAppointments,
});

export default connect(mapStateToProps, { closeModal, upcommingAppointments })(
	ScheduleMeeting
);
